import React, { useState } from "react";
import emailjs from "emailjs-com";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [messageSent, setMessageSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_bdz6e39", // Replace with your EmailJS service ID
        "template_bdylox5", // Replace with your EmailJS template ID
        e.target, // Form reference
        "4iwJKFEaIYzkBLWwC" // Replace with your EmailJS user ID (public key)
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setMessageSent(true);
          setFormData({ name: "", email: "", subject: "", message: "" });

          // Hide success message after 3 seconds
          setTimeout(() => {
            setMessageSent(false);
          }, 10000);
        },
        (error) => {
          console.error("Error sending email:", error.text);
        }
      );
  };

  return (
    <div className="contact-container">
      <Sidebar />
      <h1>Contact Me</h1>

      {messageSent && <div className="success-message">Message Sent Successfully!</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="subject">Subject:</label>
          <input
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">
          <span>Submit <FontAwesomeIcon icon={faPaperPlane} /></span>
        </button>
      </form>

      <Footer />
    </div>
  );
};

export default Contact;
